import "./Login.css"; // reuse the same CSS styling
import SignUpForm from "../components/forms/SignUpForm";

function SignupPage() {
    const handleSignup = (e) => {
        e.preventDefault();
        // frontend only, no backend yet
        console.log("Signup form submitted!");
    };

    return (
        <div className="auth-page">
            <div className="auth-left">
                <div className="auth-form-container">
                    <SignUpForm />
                    <div className="auth-footer">
                        <span>Heb je al een account? <a className="highlighted" href="/login">Log in</a></span>
                    </div>
                </div>
                <p className="auth-copy">© Kurtosis B.V. 2025 &nbsp; ✉️ Continuemee@kurtosis.nl</p>
            </div>

            <div className="auth-right" style={{ backgroundImage: `url("/login-bg2.png")` }}>
                <div className="auth-overlay">
                    <img src="/arrow-draw.png" alt="arrow" className="arrow-draw" />
                    <blockquote>
                        “De gedachten die we denken en de woorden die we uitspreken creëren onze ervaringen.”
                    </blockquote>
                    <p className="author">
                        <strong>Louise L. Hay</strong><br />
                        Amerikaanse Therapeut (1926–2017)
                    </p>
                </div>
            </div>
        </div>
    );
}

export default SignupPage;